const ADMIN_SESSION_KEY = "ai_chat_admin";

/** После успешного входа на /admin (nginx basic auth). */
export function markAdminSession(): void {
  sessionStorage.setItem(ADMIN_SESSION_KEY, "1");
}

export function clearAdminSession(): void {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}

export function hasAdminSession(): boolean {
  return sessionStorage.getItem(ADMIN_SESSION_KEY) === "1";
}
